import { Component, Prop, Vue } from "vue-property-decorator";

import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";

@Component
export default class ReadingTask3Passage extends Vue {
  private _passage: [];
  private balaTasks: any;
  /*
  passage = [
    `It was just after 11 p.m. on September 8, 1954. A 16-year-old from Toronto, Marilyn Bell, slipped into Lake Ontario. The water
    was dark and cold, lit only by the glow of lights from Youngstown, New York. From the beginning, Marilyn set a steady pace.
    Her goal—a beach near Toronto—was more than 50 kilometres away.`,
    `Through the early hours of the morning, her stroke remained strong. She eventually slowed
    her speed slightly, but never stopped to rest. Her coach, following alongside in a motorboat,
    wrote encouraging messages on a blackboard and held them over the water for her to read as
    she rose for breath.`,
    `During the following day, a strong wind whipped the water into choppy waves and blew
    Marilyn off course, making her path to the opposite shore even longer.`,
    ` In Ontario, radio stations had picked up the story, and news of Marilyn’s attempt was soon
    broadcast across the country. By evening, crowds began to gather at the lakeshore. Bright
    pink flares shot into the air to help keep her on course as darkness fell.`,
    `For a moment, Marilyn stopped. She floated in the water and turned exhausted eyes toward the boat. Her coach waited, allowing
    her to make her own decision. Her parents, in a boat just behind her, struggled to stay silent. Then Marilyn turned back to the
    water and began her steady pace once more.`,
    `Twenty hours and 57 minutes after she began, Marilyn reached Canadian shores. To the cheers of thousands, she was lifted from
    the water and carried to a waiting ambulance. She was the first person in history to swim Lake Ontario.`,
    `The following year, Marilyn became the youngest person ever to swim the English Channel. Her achievements changed the
    world’s ideas about women’s athletic abilities and endurance.`
  ];
*/

  constructor() {
    super();
    this._passage = this.$store.getters.balaPassages.readingTask3;
    this.balaTasks = this.$store.getters.balaSections;
  }

  beforeCreate() {
    this._passage = this.$store.getters.balaPassages.readingTask3;
    this.balaTasks = this.$store.getters.balaSections;
  }

  render(h: CreateElement) {
    return (
      <Card title={this.balaTasks[3].name}>
        <div slot="mainContent">
          <v-list class="overflow-y-auto" max-height="340px">
            {this._passage.map((line, i) => (
              <v-list-item>
                <v-row>
                  <v-col cols="1">{i + 1}</v-col>
                  <v-col cols="11">
                    {this.$createElement("p", {
                      domProps: {
                        innerHTML: line
                      }
                    })}
                  </v-col>
                </v-row>
              </v-list-item>
            ))}
          </v-list>
        </div>
        <div slot="actions">
          <v-spacer></v-spacer>
          <v-btn color="secondary" to="understanding">
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(this.$store.getters.progressBala)}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }
}

const component = ReadingTask3Passage;
